exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-allcourse-tsx": () => import("./../../../src/pages/allcourse.tsx" /* webpackChunkName: "component---src-pages-allcourse-tsx" */),
  "component---src-pages-course-strapi-course-name-slug-tsx": () => import("./../../../src/pages/course/{StrapiCourse.name_slug}.tsx" /* webpackChunkName: "component---src-pages-course-strapi-course-name-slug-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */)
}

